import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL


export const adminGetNdaAgreementAPI = async () => {
    try {
      const apiToken = JSON.parse(localStorage.getItem("authUser")) 
      const headers = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: apiToken,
        Accept: "application/json",
        "Cache-Control": "no-cache",
      };
      
      const response = await axios.get(`${apiBaseUrl}/superAdmin/viewAllNDAagreements`, {
        headers,
      });
  
      return response;
    } catch (error) {
      console.error("Error Uploading Designs:", error);
      throw error;
    }
  }